import Tracker from "@openreplay/tracker";

let interactionCount = 0;
let tracker: Tracker = null;

function initializeOpenRelay() {
  tracker = new Tracker({
    projectKey: process.env.NEXT_PUBLIC_OPENRELAY_KEY,
    network: {
      capturePayload: true,
    } as any,
    ingestPoint: "https://replay.captyn.com/ingest",
    obscureTextEmails: false,
    obscureTextNumbers: false,
    obscureInputEmails: false,
    obscureInputNumbers: false,
    obscureInputDates: false,
    defaultInputMode: 0,
    inlineCss: 3,
  });

  void tracker.start();
}

// Event listeners for keyboard and mouse events
function interactionHandler() {
  interactionCount += 1;

  if (interactionCount >= 2) {
    if (process.env.NEXT_PUBLIC_OPENRELAY_KEY) {
      initializeOpenRelay();
    }
    // Remove event listeners after initializing LogRocket
    document.removeEventListener("click", interactionHandler);
    document.removeEventListener("keydown", interactionHandler);
  }
}

// Adding event listeners to track user interactions
if (typeof window !== "undefined") {
  document.addEventListener("click", interactionHandler);
  document.addEventListener("keydown", interactionHandler);
}

export { tracker };
